import React, { useEffect } from "react"

const Messenger = props => {
    useEffect(() => {
        setTimeout(() => {
            window.erxesSettings = {
                ...window.erxesSettings,
                messenger: {
                    brand_id: "jbkNNb",
                }
            };
            var script = document.createElement('script');
            script.src = "https://widgets.golomtbank.com/build/messengerWidget.bundle.js";
            script.async = true;
            var entry = document.getElementsByTagName('script')[0];
            entry.parentNode.insertBefore(script, entry);
        }, 1000)

    })
    return (
        <></>
    )
}

export default Messenger;